import React, { useEffect, useState } from "react";
import Button from "../../components/Button";
import { CardHeader, ColCard, CardTitle, CardUnit } from "../../components/ContentLayout";
import timerIcon from "../../assets/images/icon/timer-icon.svg";
import Icon from "../../components/Icon";
import { Doughnut } from "react-chartjs-2";
import { diffSeconds, getDay, getDayName, getFormatDateHour, getFormatHour } from "../../utils/date";
import { getLocation } from "../../utils/gps";
import { createWorkHistoryCommute, getWorkHistoryCommuteCalendarList } from "../../apis/work-history";
import systemAlert from "../../utils/systemAlert";
import { toast } from "../../utils/toast";
import { addressByCoord } from "../../apis/maps";
import { CHART_COLORS, CHECKIN } from "../../constants/WORK";
import { isEmpty } from "../../utils/lodashExtend";

const AttendanceBoard = () => {

  const [commuteStatus, setCommuteStatus] = useState(CHECKIN.commute)
  const [status, setStatus] = useState(CHECKIN.empty)
  const [data, setData] = useState({
    labels: ['',],
    datasets: [{
      data: [100],
      backgroundColor: [
        CHECKIN.empty.chartColor
      ],
      borderWidth: 0,
      hoverOffset: 4,
    }]
  })

  const [workStartTime, setWorkStartTime] = useState('')
  const [workEndTime, setWorkEndTime] = useState('')

  /*
  labels: [
    '지각/조퇴',
    '근무',
    '연장근무'
  ],
  datasets: [{
    data: [10, 350, 100],
    backgroundColor: [
      '#FF5C6D',
      '#5C6DFF',
      '#FF9C00',
    ],
    borderWidth: 0,
    hoverOffset: 4,
  }]
  */

  const [options] = useState({
    tooltips: {
      enabled: false
    },
    cutoutPercentage: 95,
    legend: {
      display: false
    },
    layout: {
      padding: {
        left: 24,
        right: 24,
        top: 0,
        bottom: 0
      }
    },
    plugins: {
      datalabels: {
        display: false
      },
    },
  })

  const setWorkStatus = async () => {
    let targetDay = getDay()
    let _workStartTime;
    let _workEndTime;
    let chartData;
    // 기본이 출근 눌러야 하는 상태
    let _commuteStatus = CHECKIN.commute;

    const chartAddDat = (type, data) => {
      const chartStatus = CHART_COLORS.find(c => c.id === type)
      if (!chartData) {
        chartData = {
          labels: [],
          datasets: [{
            data: [],
            backgroundColor: [],
            borderWidth: 0,
            hoverOffset: 4,
          }]
        }
      }
      chartData.labels.push(chartStatus.label)
      chartData.datasets[0].data.push(data)
      chartData.datasets[0].backgroundColor.push(chartStatus.color)
    }

    const workHistory = await getWorkHistoryCommuteCalendarList({
      startDate: getDay(1),
      endDate: getDay()
    })
    const {
      workHistoryList,
      workScheduleList,
    } = workHistory.data


    // 다음 액션이 퇴근인 경우
    if (
      !isEmpty(workHistoryList)
    ) {
      const lastCommute = workHistoryList[workHistoryList.length - 1]
      // 퇴근 기록이 없는 경우 // 출근중

      const _commuteStartTime = lastCommute.commuteStartTime;
      const _commuteEndTime = lastCommute.commuteEndTime;
      _workStartTime = lastCommute.workStartTime
      _workEndTime = lastCommute.workEndTime

      // 퇴근이 없는 경우 출근중
      if (_commuteStartTime && !_commuteEndTime) {
        _commuteStatus = CHECKIN.left
      }

      if (_workStartTime && _workEndTime) {

        // CHART 계산 영역

        // 총 근무 해야 하는 시간
        const totalWorkSec = diffSeconds(_workStartTime, _workEndTime)
        // 지각시간 양수 일경우 지각
        const tardySec = diffSeconds(_workStartTime, _commuteStartTime)
        if (tardySec > 0) {
          chartAddDat('TARDY', tardySec)
          setStatus(CHECKIN.earlyLeft)
          // 
        }
        // 실제 근무 종료 시간  _commuteEndTime 가 없는 경우 근무중
        const realWorkEnd = _commuteEndTime || getFormatDateHour()
        // 연장 근무 시간
        const extendWorkSec = diffSeconds(_workEndTime, realWorkEnd)
        // 현 근무 시간
        const currentWorkSec = diffSeconds(_commuteStartTime > _workStartTime ? _commuteStartTime : _workStartTime, realWorkEnd)

        // 남은 시간
        const remainingSec = totalWorkSec - currentWorkSec - Math.max(tardySec, 0)
        // 근무시간보다 덜 한경우
        if (extendWorkSec < 0) {
          // 근무시간
          if (currentWorkSec > 0) {
            chartAddDat('WORK_TIME', currentWorkSec)
          }
          // 남은 근무시간
          // 근무 끝남
          if (_commuteEndTime) {
            // 모자른 시간
            chartAddDat('EARLY_LEFT', remainingSec)
            setStatus(CHECKIN.earlyLeft)
          } else {
            // 남은 시간
            chartAddDat('REMAINING', remainingSec)
            _commuteStatus = CHECKIN.earlyLeft
          }
          // 근무 시간 지난 경우
        } else {
          // 근무 완료
          chartAddDat('WORK_SUCCESS', currentWorkSec)
          // TODO 연장 근무 인 경우 추가 필요
        }

      }

    } else {

      // 다음 액션이 출근인 경우
      const workSchedule = workScheduleList.find(w => w.date === targetDay)
      // 워크 스케줄이 있는 경우
      if (workSchedule) {
        _workStartTime = workSchedule.workStartTime
        _workEndTime = workSchedule.workEndTime

      }
    }


    setWorkStartTime(getFormatHour(_workStartTime))
    setWorkEndTime(getFormatHour(_workEndTime))
    setCommuteStatus(_commuteStatus)
    if (chartData) {
      setData(chartData)
    }
  }


  useEffect(() => {
    setWorkStatus()
  }, [])


  const commute = async () => {
    systemAlert(
      `${commuteStatus.label}하시겠습니까?`,
      {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: commuteStatus.label,
            onClick: async () => {
              let coord = {}
              let address = '주소를 불러올 수 없습니다.'
              try {
                coord = await getLocation()
                address = await addressByCoord(coord)
              } catch (error) { }
              createWorkHistoryCommute({
                ...coord,
                address,
              }).then(() => {
                toast.success(commuteStatus.afterMsg)
                if (commuteStatus.label === CHECKIN.commute.label) {
                  // TODO 출근 찍으면 퇴근 or 조기퇴근 으로 설정
                  setCommuteStatus(CHECKIN.left)
                } else {
                  setCommuteStatus(CHECKIN.commute)
                }
                setWorkStatus()

              }).catch(() => {
                systemAlert(`${commuteStatus.label}에 실패 했습니다.`)
              })
            }
          }
        ]
      }
    )
  }

  return <>
    <ColCard
      type="light"
      className="attendance-board"
    >
      <CardHeader className="border-bottom-none">
        <CardTitle>
          오늘의 근무
        </CardTitle>
        <CardUnit>
          {getDay(0, 'M/D')} {getDayName()}
        </CardUnit>
      </CardHeader>
      <div className="attendance-chart">
        <div className="attendance-chart-pannel">
          <Icon
            src={timerIcon}
            className={`icon-${status.color}`}
          />
          {workStartTime && workEndTime ? <>
            {workStartTime}
            &nbsp;-&nbsp;
            {workEndTime}
          </>
            : <>근무일이 아닙니다</>}
        </div>
        <Doughnut
          width={100}
          height={100}
          data={data}
          options={options}
        />
      </div>
      <Button
        color={commuteStatus.color}
        size={"lg"}
        className="w-full"
        onClick={commute}
      >
        {commuteStatus.label}
      </Button>
    </ColCard>
  </>
}

export default AttendanceBoard